import { useServiceCardsQuery } from '@app/features/services';
import { useMemo } from 'react';

export const useLoyalityServices = (): ReturnType<typeof useServiceCardsQuery> => {
  const resp = useServiceCardsQuery({});
  const data = useMemo(() => resp.data.filter((service) => !!service.discountLevels?.length), [resp.data]);
  return { ...resp, data };
};
